import { render, staticRenderFns } from "./CourseLivePage.vue?vue&type=template&id=d335ce86&scoped=true"
import script from "./CourseLivePage.vue?vue&type=script&lang=js"
export * from "./CourseLivePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d335ce86",
  null
  
)

export default component.exports